import { 
  Car as PhCar,
  Truck as PhTruck,
  Motorcycle as PhMotorcycle,
  Van as PhVan,
  Boat as PhBoat,
  Tractor as PhTractor,
  Crane as PhCrane,
  Package as PhPackage,
  Jeep as PhJeep,
  IconProps
} from '@phosphor-icons/react';
import { ComponentType } from 'react';

export type VehicleType = 
  | 'car' 
  | 'truck' 
  | 'motorcycle' 
  | 'van' 
  | 'boat' 
  | 'agricultural' 
  | 'construction' 
  | 'trailer' 
  | 'atv';

export type PhosphorIcon = ComponentType<IconProps>;

export const vehiclePhosphorIcons: Record<VehicleType, PhosphorIcon> = {
  car: PhCar,
  truck: PhTruck,
  motorcycle: PhMotorcycle,
  van: PhVan,
  boat: PhBoat,
  agricultural: PhTractor,
  construction: PhCrane,
  trailer: PhPackage,
  atv: PhJeep,
};

export const vehicleLabels: Record<VehicleType, string> = {
  car: 'Mașini',
  truck: 'Camioane',
  motorcycle: 'Motociclete',
  van: 'Autoutilitare',
  boat: 'Ambarcațiuni',
  agricultural: 'Utilaje Agricole',
  construction: 'Utilaje Construcții',
  trailer: 'Remorci',
  atv: 'ATV/UTV',
};

export const getVehiclePhosphorIcon = (type: string): PhosphorIcon => {
  return vehiclePhosphorIcons[type as VehicleType] || PhCar;
};

export const getVehicleLabel = (type: string): string => {
  return vehicleLabels[type as VehicleType] || 'Vehicul';
};
